import React, { Component } from "react";
import ApexCharts from 'apexcharts'

export default class CallInitiated extends Component {
    state = { chart: null }

    componentDidMount = () => {
        this.load();
    }

    load = () => {
        let value = this.props.value? this.props.value: 0;
        const chartHeight = 200;
        const chartWidth = 150;
        let options = {
            series: [this.props.percent],
            chart: {
                height: chartHeight,
                width: chartWidth,
                type: 'radialBar',
                offsetY: -10
            },
            colors: ['#287150'],
            tooltip: {
                enabled: true,
                style: {
                    backgroud: 'white',
                    fontSize: '12px',
                    fontFamily: undefined
                },
                y: {
                    formatter: (value) => { return value + "%" },
                }
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '60%'
                    },
                    // startAngle: -360,
                    // endAngle: 360,
                    dataLabels: {
                        name: {
                            show: false   // 👈 this removes "Email Sent"
                        },
                        value: {
                            offsetY: 13,
                            fontSize: "22px",
                            formatter: function () {
                                return value;
                            }
                        }
                    }
                }
            },
           
            labels: ['Call Initiated'],
        }
        var chart = new ApexCharts(document.querySelector("#callInitiated"), options);
        chart.render();
        this.setState({ chart: chart })
    }

    componentDidUpdate = (prevProps) => {
		if(this.props.percent !== prevProps.percent){
			if(this.state.chart) this.state.chart.destroy();
			this.load();
		}
	}
    
    render() {
        return (
            <div id="callInitiated" className="chart-container"></div>
        );
    }
}